import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

export default function LegalNotice() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-gradient-to-b from-[#1a1a1a] via-[#0f0f0f] to-[#1a1a1a] min-h-screen text-white">
      {/* Navigation */}
      <nav className="bg-[#0f0f0f]/95 backdrop-blur-lg border-b border-white/8">
        <div className="max-w-[1400px] mx-auto px-8 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/986c59b2-a2b4-4fd2-b575-bd141709e178.png"
              alt="NOKX GLOBAL LTD"
              className="h-10 w-auto"
            />
          </Link>
          <Link
            to="/"
            className="px-6 py-2.5 border border-white/30 rounded-full text-white text-sm tracking-wide hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-arrow-left-line"></i>
            {t('legal.backHome')}
          </Link>
        </div>
      </nav>

      {/* Header */}
      <header className="pt-20 pb-12">
        <div className="max-w-[900px] mx-auto px-8">
          <p className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-5">
            {t('legal.label')}
          </p>
          <h1 className="text-4xl lg:text-5xl font-light mb-4">{t('legal.title')}</h1>
          <p className="text-[#888888] text-sm">{t('legal.lastUpdated')}: 2025-06-18</p>
        </div>
      </header>

      {/* Content */}
      <main className="pb-32">
        <div className="max-w-[900px] mx-auto px-8 space-y-16">

          {/* Company Information */}
          <section className="space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 flex items-center justify-center bg-[#d4af37]/10 rounded-lg">
                <i className="ri-building-2-line text-lg text-[#d4af37]"></i>
              </div>
              <h4 className="text-xl font-medium text-white">
                <a href="#company-info" id="company-info">{t('legal.companyInfo')}</a>
              </h4>
            </div>
            <div className="bg-[#242424] rounded-2xl p-8 border border-white/8 space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <p className="text-xs text-[#888888] uppercase tracking-wider mb-1">{t('legal.companyName')}</p>
                  <p className="text-white font-medium">NOKX GLOBAL LTD</p>
                </div>
                <div>
                  <p className="text-xs text-[#888888] uppercase tracking-wider mb-1">{t('legal.companyNumber')}</p>
                  <p className="text-white font-medium">14136951</p>
                </div>
                <div>
                  <p className="text-xs text-[#888888] uppercase tracking-wider mb-1">{t('legal.companyType')}</p>
                  <p className="text-white font-medium">{t('legal.privateLimited')}</p>
                </div>
                <div>
                  <p className="text-xs text-[#888888] uppercase tracking-wider mb-1">{t('legal.incorporatedOn')}</p>
                  <p className="text-white font-medium">27 May 2022</p>
                </div>
                <div className="md:col-span-2">
                  <p className="text-xs text-[#888888] uppercase tracking-wider mb-1">{t('legal.registeredAddress')}</p>
                  <p className="text-white font-medium">71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ</p>
                </div>
                <div>
                  <p className="text-xs text-[#888888] uppercase tracking-wider mb-1">{t('legal.companyStatus')}</p>
                  <p className="text-[#4ade80] font-medium flex items-center gap-2">
                    <span className="w-2 h-2 bg-[#4ade80] rounded-full inline-block"></span>
                    {t('legal.active')}
                  </p>
                </div>
                <div>
                  <p className="text-xs text-[#888888] uppercase tracking-wider mb-1">{t('legal.businessActivity')}</p>
                  <p className="text-white font-medium text-sm">47910 - {t('legal.sicDescription')}</p>
                </div>
              </div>
            </div>
          </section>

          {/* Nature of Services */}
          <section className="space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 flex items-center justify-center bg-[#d4af37]/10 rounded-lg">
                <i className="ri-service-line text-lg text-[#d4af37]"></i>
              </div>
              <h4 className="text-xl font-medium text-white">
                <a href="#services" id="services">{t('legal.servicesTitle')}</a>
              </h4>
            </div>
            <div className="space-y-4 text-[#b8b8b8] text-sm leading-relaxed">
              <p>{t('legal.servicesP1')}</p>
              <p>{t('legal.servicesP2')}</p>
              <p><strong className="text-white">{t('legal.servicesDisclaimer')}</strong></p>
            </div>
          </section>

          {/* Intellectual Property */}
          <section className="space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 flex items-center justify-center bg-[#d4af37]/10 rounded-lg">
                <i className="ri-copyright-line text-lg text-[#d4af37]"></i>
              </div>
              <h4 className="text-xl font-medium text-white">
                <a href="#ip" id="ip">{t('legal.ipTitle')}</a>
              </h4>
            </div>
            <div className="space-y-4 text-[#b8b8b8] text-sm leading-relaxed">
              <p>{t('legal.ipP1')}</p>
              <p>{t('legal.ipP2')}</p>
            </div>
          </section>

          {/* Limitation of Liability */}
          <section className="space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 flex items-center justify-center bg-[#d4af37]/10 rounded-lg">
                <i className="ri-shield-line text-lg text-[#d4af37]"></i>
              </div>
              <h4 className="text-xl font-medium text-white">
                <a href="#liability" id="liability">{t('legal.liabilityTitle')}</a>
              </h4>
            </div>
            <div className="space-y-4 text-[#b8b8b8] text-sm leading-relaxed">
              <p>{t('legal.liabilityP1')}</p>
              <p>{t('legal.liabilityP2')}</p>
              <p>{t('legal.liabilityP3')}</p>
            </div>
          </section>

          {/* Data Protection & Privacy */}
          <section className="space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 flex items-center justify-center bg-[#d4af37]/10 rounded-lg">
                <i className="ri-lock-line text-lg text-[#d4af37]"></i>
              </div>
              <h4 className="text-xl font-medium text-white">
                <a href="#privacy" id="privacy">{t('legal.privacyTitle')}</a>
              </h4>
            </div>
            <div className="space-y-4 text-[#b8b8b8] text-sm leading-relaxed">
              <p>{t('legal.privacyP1')}</p>
              <ul className="list-disc list-inside space-y-2 ml-2">
                <li>{t('legal.privacyL1')}</li>
                <li>{t('legal.privacyL2')}</li>
                <li>{t('legal.privacyL3')}</li>
                <li>{t('legal.privacyL4')}</li>
              </ul>
              <p>{t('legal.privacyP2')}</p>
            </div>
          </section>

          {/* Payment Terms */}
          <section className="space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 flex items-center justify-center bg-[#d4af37]/10 rounded-lg">
                <i className="ri-bank-card-line text-lg text-[#d4af37]"></i>
              </div>
              <h4 className="text-xl font-medium text-white">
                <a href="#payment" id="payment">{t('legal.paymentTitle')}</a>
              </h4>
            </div>
            <div className="space-y-4 text-[#b8b8b8] text-sm leading-relaxed">
              <p>{t('legal.paymentP1')}</p>
              <p>{t('legal.paymentP2')}</p>
            </div>
          </section>

          {/* Refund Policy */}
          <section className="space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 flex items-center justify-center bg-[#d4af37]/10 rounded-lg">
                <i className="ri-refund-2-line text-lg text-[#d4af37]"></i>
              </div>
              <h4 className="text-xl font-medium text-white">
                <a href="#refund" id="refund">{t('legal.refundTitle')}</a>
              </h4>
            </div>
            <div className="space-y-4 text-[#b8b8b8] text-sm leading-relaxed">
              <p>{t('legal.refundP1')}</p>
              <p>{t('legal.refundP2')}</p>
            </div>
          </section>

          {/* Governing Law */}
          <section className="space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 flex items-center justify-center bg-[#d4af37]/10 rounded-lg">
                <i className="ri-scales-3-line text-lg text-[#d4af37]"></i>
              </div>
              <h4 className="text-xl font-medium text-white">
                <a href="#governing-law" id="governing-law">{t('legal.governingTitle')}</a>
              </h4>
            </div>
            <div className="space-y-4 text-[#b8b8b8] text-sm leading-relaxed">
              <p>{t('legal.governingP1')}</p>
            </div>
          </section>

          {/* Contact */}
          <section className="space-y-6">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-8 h-8 flex items-center justify-center bg-[#d4af37]/10 rounded-lg">
                <i className="ri-mail-line text-lg text-[#d4af37]"></i>
              </div>
              <h4 className="text-xl font-medium text-white">
                <a href="#contact-legal" id="contact-legal">{t('legal.contactTitle')}</a>
              </h4>
            </div>
            <div className="bg-[#242424] rounded-2xl p-8 border border-white/8 space-y-3">
              <p className="text-white font-medium">NOKX GLOBAL LTD</p>
              <p className="text-[#b8b8b8] text-sm">71-75 Shelton Street, Covent Garden, London, WC2H 9JQ</p>
              <p className="text-[#b8b8b8] text-sm">{t('legal.companyNumber')}: 14136951</p>
              <a href="mailto:contact@robotconcierge.store" className="text-[#d4af37] text-sm hover:text-white transition-colors cursor-pointer">
                contact@robotconcierge.store
              </a>
            </div>
          </section>

        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#0f0f0f] border-t border-white/8 py-12">
        <div className="max-w-[900px] mx-auto px-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#666666]">
            &copy; {new Date().getFullYear()} NOKX GLOBAL LTD. {t('legal.allRightsReserved')}
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            rel="nofollow"
            className="text-xs text-[#555555] hover:text-[#888888] transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </footer>
    </div>
  );
}
